import { useEffect, useRef } from 'react';
import { observable, action } from 'mobx';
import Macy from 'macy';
import debounce from 'lodash.debounce';
import BaseStore from '@src/utils/store/base-store';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import ImageLoader from './utils/image-loader';

// 每次加载图片的数量
const MAX_LOAD_IMAGE_COUNT = 40;

class WallpaperStore extends BaseStore {
  originPhotos = [];
  @observable photos = [];
  @observable loading = false;
  @observable start = 0;
  @observable end = MAX_LOAD_IMAGE_COUNT;
  @observable done = false;

  imageLoader = new ImageLoader();
  masonry = null;

  /**
   * 实例化瀑布流
   */
  createWall() {
    this.masonry = new Macy({
      container: '#wallMain', // 图像列表容器id
      trueOrder: false, // 不设置的话会顺序会乱
      waitForImages: true,
      useOwnImageLoader: false,
      mobileFirst: false,
      debug: true,
      refresh: false,
      //设置列数
      columns: 4,
      margin: {
        x: 22,
        y: 22
      }
    });
    this.masonry.on(this.masonry.constants.EVENT_INITIALIZED, function(ctx) {});
  }

  @action
  loadImages = (images = []) => {
    this.loading = true;
    images = images.slice(this.start, this.end);
    this.imageLoader.loadImages(images.map(i => ({ src: i.thumb }))).then(res => {
      res.sort((a, b) => a.index - b.index).forEach(i => {
        this.photos.push(images.find(i2 => i2.thumb === i.src));
      });
      this.masonry.runOnImageLoad(() => {
        this.masonry.recalculate();
        this.loading = false;
      });
      if (images.length >= this.end) {
        this.start = this.end;
        this.end = this.start + 20;
        this.done = false;
      } else {
        this.done = true;
      }
    });
  };

  @action
  handleScroll = e => {
    console.log(this.loading, this.done);
    if (this.loading || this.done) {
      return;
    }
    // 滚动到接近底部请求接口
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      this.loadImages(this.originPhotos);
    }
  };

  backTop = () => {
    this.containerRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  use() {
    super.use();
    this.containerRef = useRef(null);
    const pageData = useFunLinkPageData();

    useEffect(
      () => {
        this.createWall();

        if (pageData) {
          this.originPhotos = pageData.wallpaperList.map(i => ({ ...i, src: i.wallpaper_url, thumb: i.wallpaper_thumb }));
          this.loadImages(this.originPhotos);
        }

        if (this.containerRef.current) {
          this.containerRef.current.addEventListener('scroll', this.handleScroll);
        }

        const onResize = debounce(() => {
          this.createWall();
        }, 500);
        window.addEventListener('resize', onResize);

        return () => {
          if (this.containerRef.current) {
            this.containerRef.current.removeEventListener('scroll', this.handleScroll);
          }
          window.removeEventListener('resize', onResize);
        };
      },
      [pageData]
    );
  }
}

export default WallpaperStore;
